export default "__VITE_ASSET__0a20fdcc__"